import React, { ReactNode, ElementType } from "react";
import styles from "./BaseTypography.module.css";

export type BaseTypographyType = {
  className?: string;
  children?: ReactNode;

  /** Variant props */
  type: "heading" | "body" | "caption" | "code";

  /** Size props - only applies to body and code types */
  size?: "sm" | "md" | "lg" | "xl";

  /** Typography style props */
  bold?: boolean;

  /** Heading level - only applies to heading type */
  level?: 1 | 2 | 3 | 4 | 5 | 6 | "mega";

  /** Semantic props */
  as?: ElementType;
};

const BaseTypography = ({
  className = "",
  children,
  type,
  size = "md",
  bold = false,
  level = 1,
  as,
}: BaseTypographyType) => {
  // Determine the HTML element to render
  const getElementType = (): ElementType => {
    if (as) return as;

    if (type === "heading") {
      if (level === "mega") return "h1";
      return `h${level}` as ElementType;
    }

    if (type === "caption") return "caption";
    
    if (type === "code") return "code";

    // Default to span for body text
    return "span";
  };

  const Element = getElementType();
  const componentId = `quill-typography-${type}-${
    type === "body" || type === "code" ? size : level
  }`;

  return (
    <Element
      className={[styles.root, className, "quill-ui-next-component"].join(" ")}
      data-id={componentId}
      data-type={type}
      data-size={type === "body" || type === "code" ? size : undefined}
      data-level={type === "heading" ? level : undefined}
      data-bold={bold}
    >
      {children}
    </Element>
  );
};

export default BaseTypography;
